export const BASE_LOCALE = 'en';
